export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14753.83e2449e.jpg";